<template>
  <confirm-modal
    :visible.sync="dialogVisible"
    :title="modalTextos.titulo"
    :leftButton="{
      show: true,
      text: i18n.geral.cancelar,
      closeOnClick: true
    }"
    :rightButton="{
      show: true,
      text: i18n.geral.confirmar,
      onClick: handleConfirm
    }"
    @close="handleClose"
  >
    <p class="modal-descricao" v-html="modalTextos.descricao"></p>
    <label class="modal-label">{{ i18n.conta.login.labelCpfPassaporte }}</label>
    <input-cpf-passaporte
      :value="value"
      @input="$emit('input', $event)"
      :placeholder="i18n.conta.login.placeholderCpfPassaporte"
      @enter="handleConfirm"
      border-color="#295661"
    />
  </confirm-modal>
</template>

<script>
import ConfirmModal from "./ConfirmModal.vue";
import InputCpfPassaporte from "@/components/common/InputCpfPassaporte.vue";

const FLUXOS = ["emailConfirmacao", "redefinicaoSenha"];

export default {
  name: "SolicitacaoCpfPassaporteModal",
  components: {
    ConfirmModal,
    InputCpfPassaporte
  },
  props: {
    fluxo: {
      type: String,
      required: true,
      validator(v) {
        return FLUXOS.includes(v);
      }
    },
    visible: {
      type: Boolean,
      required: true
    },
    value: {
      type: String,
      required: true
    }
  },
  computed: {
    i18n() {
      return this.$i18n.messages[this.$i18n.locale].interface;
    },
    modalTextos() {
      return this.i18n.conta[this.fluxo].modal;
    },
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit("update:visible", false);
      this.$emit("input", "");
    },
    handleConfirm() {
      this.$emit("confirm", {
        fluxo: this.fluxo,
        identificador: this.value
      });
    }
  }
};
</script>

<style scoped>
.modal-descricao {
  margin-bottom: 25px;
  font-size: 15px;
}
.modal-label {
  margin-bottom: 10px;
  font-size: 14px;
}
</style>
